import { render, staticRenderFns } from "./choosePic.vue?vue&type=template&id=7f44d7a0&scoped=true&"
import script from "./choosePic.vue?vue&type=script&lang=js&"
export * from "./choosePic.vue?vue&type=script&lang=js&"
import style0 from "./choosePic.vue?vue&type=style&index=0&id=7f44d7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f44d7a0",
  null
  
)

export default component.exports